const QUERIES = {
  USERS_LIST: 'users-list',
  APP_LIST: 'app-list',
  OCPP_LOG_LIST: 'ocpp-log-list',
}

export {QUERIES}
